module.exports = __webpack_public_path__ + "static/media/App_Store_Badge.53370f0d.png";